var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "125.2,0 125.2,50.3 175.5,50.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.9,100c-2.8-2.8-7.7-2.8-10.5,0l-27,27c-1.4,1.4-2.2,3.3-2.2,5.2c0,2,0.8,3.8,2.2,5.2l27,27c1.4,1.4,3.2,2.2,5.2,2.2 c2,0,3.8-0.8,5.2-2.2c0.7-0.7,1.3-1.6,1.6-2.4c1.1-2.7,0.5-5.9-1.6-8l-21.8-21.7l21.8-21.8C65.7,107.6,65.7,102.9,62.9,100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5,130c-1.2-1.2-2.8-1.9-4.5-1.9h0c-1.7,0-3.3,0.7-4.5,1.9l-9.2,9.2l0-29.2c0-3.5-2.9-6.4-6.3-6.4s-6.3,2.9-6.3,6.4 v29.2l-9.2-9.2c-2.4-2.4-6.5-2.4-9,0c-1.2,1.2-1.9,2.8-1.9,4.5c0,1.7,0.7,3.3,1.9,4.5l20,20c1.2,1.2,2.8,1.9,4.5,1.9 s3.3-0.7,4.5-1.9l20-20h0c1.2-1.2,1.8-2.7,1.9-4.4C126.4,132.8,125.7,131.2,124.5,130z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6,127l-27-27c-2.7-2.7-7-2.9-9.9-0.5l0,0c0,0,0,0,0,0l-0.7,0.7c-2.7,2.9-2.6,7.4,0.2,10.2l21.7,21.8L137.2,154 c-1.4,1.4-2.2,3.2-2.2,5.2c0,2,0.8,3.8,2.2,5.2c1.4,1.4,3.3,2.1,5.2,2.1c1.9,0,3.8-0.7,5.2-2.1l27-27c1.4-1.4,2.2-3.3,2.2-5.2 S176,128.4,174.6,127z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.2,64.2h-49c-7.6,0-13.9-6.2-13.9-13.9v-49H49.7C36.5,1.3,25.8,12,25.8,25.2v57.1h148.4V64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7,200h100.6c10.5,0,19.3-6.8,22.5-16.2H27.2C30.4,193.2,39.2,200,49.7,200z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLog);
export default __webpack_public_path__ + "static/media/download-log.87221ec95db74f03bf2f4c9d5e3266ec.svg";
export { ForwardRef as ReactComponent };